import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { Router, NavigationEnd, NavigationStart, NavigationError, ActivatedRoute, NavigationCancel, Params } from '@angular/router';
import { FormControl, FormGroup, NgForm } from '@angular/forms';
import { Globals } from 'src/app/globals';

@Component({
    selector: 'success',
    templateUrl: './success.component.html',
    styleUrls: ['./success.component.css']
})
export class SuccessComponent implements OnInit {
  
  errMsg: string = "";
  constructor(private route: ActivatedRoute, public router: Router,public globals: Globals) {}
        
  ngOnInit() {}

  GoToBackPage() {
    window.location.href = this.globals.REDIRECT_URL+'sendLinkToCustomer?from=ekyc';
  }
}